export const integrationsRoutes = {
  integrationServices: () => '/integrations',
};
